'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
const $ = require("jquery");
const init_1 = require("./class/init");
const scroll_1 = require("./class/common/scroll");
const manufacturing_slider_1 = require("./class/about/manufacturing-slider");
const conatct_1 = require("./class/contact/conatct");
const modal_1 = require("./class/about/modal");
const change_tab_1 = require("./class/about/change-tab");
const dropdown_language_menu_1 = require("./class/common/dropdown-language-menu");
const show_sp_menu_1 = require("./class/common/show-sp-menu");
const to_top_button_1 = require("./class/common/to-top-button");
const header_change_1 = require("./class/common/header-change");
const youtube_1 = require("./class/top/youtube");
const panel_1 = require("./class/top/panel");
const modal_2 = require("./class/top/modal");
const nano_slider_1 = require("./class/about/nano-slider");
const accordion_1 = require("./class/sustainability/accordion");
const inertial_scrolling_1 = require("./class/sustainability/inertial-scrolling");
const history_slider_1 = require("./class/company/history-slider");
$(() => {
    new init_1.default();
    new manufacturing_slider_1.default();
    new conatct_1.default();
    new modal_1.default();
    new change_tab_1.default();
    new dropdown_language_menu_1.default();
    new show_sp_menu_1.default();
    new to_top_button_1.default();
    new header_change_1.default();
    new youtube_1.default();
    new panel_1.default();
    new modal_2.default();
    new nano_slider_1.default();
    new accordion_1.default();
    new inertial_scrolling_1.default();
    new history_slider_1.default();
});
new scroll_1.default();
